/**
 * Create a new group
 * @author Ryan Gladstone, Umer Hassan
 */

function GroupCreateController(
  $scope,
  $translate,
  $log,
  groupsService,
  analyticsService,
  websites,
  featureFlag
) {
  $scope.websites = websites;
  $scope.alerts = [];

  $scope.group = {};

  $scope.tasksv2enabled = false;
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    $scope.tasksv2enabled = enabled;
  });

  $scope.create = () => {
    $scope.alerts = [];

    groupsService
      .createGroup({ name: $scope.group.name, website: $scope.group.website })
      .then(
        (response) => {
          $scope.group = response;
          $scope.alerts.push({
            type: 'success',
            msg: $translate.instant('GROUP_CREATED')
          });
          analyticsService.trackEvent('Group management', 'Created group');
        },
        (response) => {
          $log.error(
            'GroupCreateController groupsService.createGroup() error: ',
            response
          );
          $scope.alerts.push({
            type: 'danger',
            msg: $translate.instant('ERROR_CREATING_GROUP', {
              name: $scope.group.name
            })
          });
        }
      );
  };

  $scope.onSelectWebsite = (id) => {
    $scope.group.website = id;
  };
}

const arr = [
  '$scope',
  '$translate',
  '$log',
  'groupsService',
  'analyticsService',
  'websites',
  'featureFlag',
  GroupCreateController
];

export default function (ngModule) {
  ngModule.controller('GroupCreateController', arr);
}
